import moment from 'moment'
import { isUpperCase } from "is-upper-case";

export function unCamelCase (str) {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2')
  str = str.toLowerCase() // add space between camelCase text
  return str
}

/**
 * "Safer" String.toUpperCase()
 */
export function upperCase (str) {
  return str.toUpperCase()
}

/**
 * UPPERCASE first char of each word. Otherwise known as title case
 */
export function properCase (str,ignoreUpperCase=false) {
  if(isUpperCase(str) && ignoreUpperCase || typeof str != 'string'){
    return str
  }
  return str.toLowerCase().replace(/^\w|\s\w/g, upperCase)
}

export function lowerCaseFirstLetter (str) {
  return str.charAt(0).toLowerCase() + str.slice(1)
}

export function formatCurrency (val) {
  const num = Number(val)
  if (isNaN(num)) return ''
  const formattedValue = num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${formattedValue}`
}

export function colourToString (colour) {
  try {
    return colour.group + ' (' + colour.name + ')'
  } catch (ex) {
    return ''
  }
}

export function formatMonth (dt) {
  if (!dt) return null
  return moment(dt).format('MMMM YYYY')
}

export function formatDate (dt) {
  if (!dt) return null
  return moment(dt).format('DD/MM/YYYY')
}

export function formatDateTime (dt) {
  if (!dt) return null
  return moment(dt).format('DD/MM/YY hh:mm a')
}

export function fromNow (t) {
  if (!t) return '-'
  return moment(t).fromNow()
}
